/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import userApi from 'api/user.api';
import { createFOAsyncThunk } from '../../../helpers/thunk.helpers';

/* Thunks */
export const sendInvitations = createFOAsyncThunk('inviteUsers/sendInvitations', async args =>
  userApi.sendInvitations(args.orgId, args.invitations),
);
